var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import uuid from 'uuid';
import { ConfirmInput } from './ConfirmInput';
import { ConfirmModal } from './ConfirmModal';
function createModalContext() {
    var Context = React.createContext(
    // tslint:disable-next-line:no-object-literal-type-assertion
    {});
    var AppProvider = function (props) {
        var children = props.children;
        var _a = React.useState([]), components = _a[0], setComponents = _a[1];
        var addModalComponent = React.useCallback(function (render, externalOptions) {
            return new Promise(function (resolve) {
                var key = uuid.v4();
                var onConfirm = function (v) {
                    resolve(v);
                    setComponents(function (list) {
                        var item = list.find(function (value) { return value.key === key; });
                        if (item) {
                            item.options = __assign(__assign({}, item.options), { isOpen: false });
                            return __spreadArrays(list);
                        }
                        return list;
                    });
                    setTimeout(function () {
                        // just wait for any animation to end.
                        setComponents(function (list) {
                            return __spreadArrays(list.filter(function (i) { return i.key !== key; }));
                        });
                    }, 3000);
                };
                setComponents(function (list) {
                    return __spreadArrays(list, [
                        {
                            render: function (options) { return render(key, options); },
                            key: key,
                            options: __assign(__assign({}, externalOptions), { onConfirm: onConfirm, isOpen: true, key: key }),
                        },
                    ]);
                });
            });
        }, []);
        var confirm = React.useCallback(function (options) {
            return addModalComponent(function (key, confirmModalOptions) { return React.createElement(ConfirmModal, __assign({}, confirmModalOptions, { key: key })); }, options);
        }, [addModalComponent]);
        var confirmInput = React.useCallback(function (options) {
            return addModalComponent(function (key, confirmInputOptions) { return React.createElement(ConfirmInput, __assign({}, confirmInputOptions, { key: key })); }, options);
        }, [addModalComponent]);
        var context = {
            confirm: confirm,
            confirmInput: confirmInput,
        };
        return (React.createElement(Context.Provider, { value: context },
            children,
            React.createElement("div", null, components.map(function (_a) {
                var render = _a.render, options = _a.options;
                return render(options);
            }))));
    };
    return { Context: Context, Provider: AppProvider };
}
var _a = createModalContext(), ODModalContext = _a.Context, Provider = _a.Provider;
export var ODModalProvider = Provider;
export function useODModalContext() {
    return React.useContext(ODModalContext);
}
//# sourceMappingURL=useODModalContext.js.map